export default __webpack_public_path__ + "static/media/medium.1e86f2c9.svg";